import { IconButton, Stack, Typography } from '@mui/material';
import { DynamicIcon } from 'src/components';

interface MacrosModalEditorHeaderProps {
  title: string;
  onBack: () => void;
}

export const MacrosModalEditorHeader = ({ title, onBack }: MacrosModalEditorHeaderProps) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBack} size="small">
          <DynamicIcon name="arrow_back" />
        </IconButton>
        <Typography variant="overline" color="text.secondary">
          {title}
        </Typography>
      </Stack>
    </Stack>
  );
};
